module.exports = __webpack_public_path__ + "img/EXEMPLO_NOME_DO_PRODUTO_PLATAFORMA.7188837b.jpg";